module.exports = __webpack_public_path__ + "img/about-marido-bg.55abe374.png";